import { configQuery, ModalSize, modalService, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __assign, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { notificationService } from '@gig/magic-messaging';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { getRealityCheckApi } from '../../services/reality-check.js';

var DEFAULT_INTERVAL = 3600000;
/**
 * Prompter which uses the reality check service to
 * display the reality check component every set period of time
 */
var RealityCheckPrompterComponent = /** @class */ (function (_super) {
    __extends(RealityCheckPrompterComponent, _super);
    function RealityCheckPrompterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Reality check configuration for current user jurisdiction
         */
        _this.rcConfig = {
            required: false,
            interval: 0,
            duration: 0,
            message: '',
        };
        _this.currentJurisdiction = null;
        _this.modalOpen = false;
        return _this;
    }
    Object.defineProperty(RealityCheckPrompterComponent.prototype, "interval", {
        get: function () {
            return this.rcConfig.interval * 60 * 1000 || DEFAULT_INTERVAL;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RealityCheckPrompterComponent.prototype, "dismissible", {
        get: function () {
            return this.rcConfig.duration === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RealityCheckPrompterComponent.prototype, "duration", {
        get: function () {
            return this.dismissible ? this.interval : this.rcConfig.duration;
        },
        enumerable: false,
        configurable: true
    });
    RealityCheckPrompterComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 1:
                        _a.currentJurisdiction = (_b.sent());
                        configQuery('realityCheck', function (realityCheck) {
                            var _a;
                            if (realityCheck) {
                                _this.rcConfig = realityCheck === null || realityCheck === void 0 ? void 0 : realityCheck[_this.currentJurisdiction];
                                if ((_a = _this.rcConfig) === null || _a === void 0 ? void 0 : _a.required) {
                                    _this.initRcService();
                                }
                            }
                            else {
                                _this.rcConfig = {
                                    required: false,
                                    interval: 0,
                                    duration: 0,
                                    message: '',
                                };
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RealityCheckPrompterComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.rcService) === null || _a === void 0 ? void 0 : _a.destroy();
        this.rcService = null;
    };
    RealityCheckPrompterComponent.prototype.initRcService = function () {
        var user = magic.session.getUser();
        this.rcService = getRealityCheckApi(!!user, user === null || user === void 0 ? void 0 : user.lastVisit, this.interval);
        if (this.currentJurisdiction === Jurisdiction.ONJN) {
            return this.ONJNInitRcService(this.rcService);
        }
        else if (this.currentJurisdiction === Jurisdiction.LOTBA) {
            return this.LOTBAInitRcService(this.rcService);
        }
    };
    RealityCheckPrompterComponent.prototype.ONJNInitRcService = function (rcService) {
        var _this = this;
        var intervalMultiplier = 1;
        var notifications = [];
        rcService.onRealityCheckInterval(function () {
            var intervalText = _this.rcConfig.interval * intervalMultiplier;
            var message = _this.$t(_this.rcConfig.message, {
                sessionTime: intervalText,
            });
            if (intervalMultiplier !== 1) {
                notificationService.close(notifications[0]);
                notifications.shift();
            }
            var notification = notificationService.show(message, {
                closeDelay: _this.interval,
                dismissible: _this.dismissible,
            });
            notifications.push(notification);
            intervalMultiplier++;
        });
    };
    RealityCheckPrompterComponent.prototype.LOTBAInitRcService = function (rcService) {
        var _this = this;
        rcService.onRealityCheckInterval(function () {
            var lotbaModal = document.createElement('magic-lotba-reality-check-modal');
            if (_this.modalOpen) {
                return;
            }
            var modalOptions = {
                onClose: function () {
                    _this.modalOpen = false;
                },
                size: ModalSize.BORDERLESS,
            };
            var modal = modalService.open(null, lotbaModal, __assign({ dismissible: false }, modalOptions));
            _this.modalOpen = true;
            lotbaModal.addEventListener('enable-close', function () {
                modalService.updateOptions(modal, __assign({ dismissible: true, dismissibleBackdrop: true }, modalOptions));
            });
        });
    };
    RealityCheckPrompterComponent.prototype.render = function () {
        return null;
    };
    RealityCheckPrompterComponent = __decorate([
        Component({
            name: 'reality-check-prompter',
        })
    ], RealityCheckPrompterComponent);
    return RealityCheckPrompterComponent;
}(Mixins(MagicConfigMixin)));

export default RealityCheckPrompterComponent;
